// Montaje de las rutas. El shell del panel (AuthGuard, Sidebar, Topbar) NO vive
// aquí: está en app/(panel)/layout.tsx, que envuelve solo a las rutas del panel
// y deja fuera al login. Ese anidamiento lo resuelve la tabla generada.
import { Suspense } from "react";
import type { ComponentType, ReactNode } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { routes, esBloque, type NodoRuta } from "./routes";

// Los layout.tsx heredados de Next reciben {children}. En React Router el hijo
// lo aporta <Outlet/>, así que se envuelven sin tocar el archivo original.
function ConLayout({ Layout }: { Layout: ComponentType<{ children: ReactNode }> }) {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

function pintar(nodos: NodoRuta[]) {
  return nodos.map((n, i) =>
    esBloque(n) ? (
      <Route key={`layout-${i}`} element={<ConLayout Layout={n.Layout} />}>
        {pintar(n.hijas)}
      </Route>
    ) : (
      <Route key={n.path} path={n.path} element={<n.Component />} />
    ),
  );
}

export default function App() {
  // fallback null: el AuthGuard tampoco pinta nada mientras resuelve la sesión,
  // así no hay parpadeo entre la carga del chunk y la comprobación.
  return (
    <Suspense fallback={null}>
      <Routes>
        {pintar(routes)}
        {/* Una dirección que no existe dejaba la pantalla en blanco: se manda
            al dashboard, y el guardia del panel pide login si hace falta. */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Suspense>
  );
}
